var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvailable = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#6659FF",
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 26C5.82 26 0 20.18 0 13 0 5.82 5.82 0 13 0c7.18 0 13 5.821 13 13 0 7.18-5.82 13-13 13z",
  transform: "translate(-312 -323) translate(28 304) translate(283 18) translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M17.478 11.017L12.538 16.051M12.538 16.051L9.991 13.457",
  transform: "translate(-312 -323) translate(28 304) translate(283 18) translate(1 1)"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvailable);
export default ForwardRef;